import { Component, Input, OnInit } from '@angular/core';
import { IonNav } from '@ionic/angular';
import { EzidebitCardPage } from '../ezidebit-card/ezidebit-card.page';
import { EzidebitAchPage } from '../ezidebit-ach/ezidebit-ach.page';
import { CaseService } from 'src/app/services/case.service';
import { CommonService } from 'src/app/services/common.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-ezidebit-method',
  templateUrl: './ezidebit-method.page.html',
  styleUrls: ['./ezidebit-method.page.scss'],
})
export class EzidebitMethodPage implements OnInit {
  @Input() caseId;
  @Input() caseData;
  @Input() amount;
  @Input() totalOutstandingWithSymbol;
  @Input() debtorDetails;
  @Input() caseDetails;

  paymentMethod = [
    {
      title: this.translate.instant('CARD_PAYMENT.TITLE'),
      type: 'card',
      icon: 'card-outline',
      src: null,
    },
    {
      title: this.translate.instant('ACH_PAYMENT.TITLE'),
      type: 'ach',
      icon: 'card-outline',
      src: 'assets/icon/ach2.svg',
    },
  ];

  constructor(
    private ionNav: IonNav,
    private caseService: CaseService,
    private commonService: CommonService,
    private translate: TranslateService
  ) {}

  ngOnInit() {
    const portalSettings = JSON.parse(localStorage.getItem('portal_settings'));
    const options = portalSettings?.payment_type?.ezidebit?.options;
    if (options && options.length) {
      this.paymentMethod = this.paymentMethod.filter(m => options.includes(m.type));
    }
  }

  handleMethodClick(type: string) {
    if (type === 'card') {
      this.commonService.showLoader();
      this.caseService.makeEzidebitPaymentRequest(this.caseId, { amount: this.amount })
        .subscribe({
          next: (res: any) => {
            this.commonService.dismissLoader();
            if (res.result) {
              this.ionNav.push(EzidebitCardPage, {
                amount:                    this.amount,
                caseId:                    this.caseId,
                totalOutstandingWithSymbol: this.totalOutstandingWithSymbol,
                debtorDetails:             this.debtorDetails,
                responseData:              res.data,
                caseDetails:               this.caseDetails,
              });
            } else {
              this.commonService.showToast(res.message, 'danger');
            }
          },
          error: () => {
            this.commonService.dismissLoader();
          },
        });
    } else if (type === 'ach') {
      this.commonService.showLoader();
      this.caseService.makeEzidebitAchPaymentRequest(this.caseId, { amount: this.amount })
        .subscribe({
          next: (res: any) => {
            this.commonService.dismissLoader();
            if (res.result) {
              this.ionNav.push(EzidebitAchPage, {
                amount:                    this.amount,
                caseId:                    this.caseId,
                totalOutstandingWithSymbol: this.totalOutstandingWithSymbol,
                debtorDetails:             this.debtorDetails,
                responseData:              res.data,
                caseDetails:               this.caseDetails,
              });
            } else {
              this.commonService.showToast(res.message, 'danger');
            }
          },
          error: () => {
            this.commonService.dismissLoader();
          },
        });
    }
  }
}
